import styled from '../../../theme'

const PageWrapper = styled.div`
  width: 100%;
`

export default PageWrapper
